/**
 * Build request body for paginated grid endpoints (POST grid).
 */
export function buildPaginationBody(config: {
  pageNumber: number;
  pageSize: number;
  searchTerm?: string;
  filter?: unknown;
}): Record<string, unknown> {
  return {
    pageNumber: config.pageNumber,
    pageSize: config.pageSize,
    searchTerm: config.searchTerm,
    filter: config.filter,
  };
}
